import { Avatar } from '@mybridge/ui/avatar';
import {
  HStack,
  Stack,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
} from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDisclosure } from '@mybridge/ui/hooks';
import { Input, InputGroup } from '@mybridge/ui/input';
import { List, ListItem } from '@mybridge/ui/list';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserFullName } from 'v4/lib/commons';
import { MyTestimonialsContext } from 'v4/snippets/profile/testimonials/context';

export const ConnectionsDropdown = ({
  value,
  defaultValue = [],
  onChange,
  max,
  type,
  ...props
}) => {
  const inputRef = useRef();
  const { allDegreeConnectionsArr = [] } =
    useSelector((state) => state.connection) ?? {};
  const allDegreeConnections = allDegreeConnectionsArr?.[0] ?? [];
  const [focused, setFocused] = useState(false);
  const disc = useDisclosure();
  const [selected, setSelected] = useState(defaultValue);
  const [search, setSearch] = useState('');
  const { t } = useTranslator();

  const context = useContext(MyTestimonialsContext) || {};
  const { givenTestimonials = [], requestedTestimonials = [] } = context;
  const containerRef = useRef(null);

  

  useEffect(() => {
    onChange?.(selected);
  }, [selected]);

  useEffect(() => {
    if (
      Array.isArray(value) &&
      JSON.stringify(value) !== JSON.stringify(selected)
    ) {
      setSelected(value);
    }
  }, [value]);

  const onSelect = (item) => {
    if (max && selected?.length >= max) return;
    const found = selected?.find((s) => s === item?.id);
    if (!found) {
      setSearch('');
      addItem(item);
      setFocused(false);
    }
  };

  const removeItem = (item) => {
    const selected_ = selected?.filter((s) => s !== item?.id);
    setSelected(selected_);
  };
  const addItem = (item) => {
    selected.push(item?.id);
    setSelected([...selected]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setFocused(false);
      }
    };

    document.addEventListener('mouseup', handleClickOutside);
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, []);


  return (
    <Stack w="100%" {...props}>
      {selected?.length ? (
        <HStack flexWrap="wrap">
          {selected
            ?.map((s) => allDegreeConnections?.find?.((as) => as?.id === s))
            ?.map((c, cind) => (
              <Tag borderRadius="full" p={2} key={cind}>
                <TagLabel>
                  <Text pl={2} maxW="150px" truncate>
                    {getUserFullName(c)}
                  </Text>
                </TagLabel>
                <TagCloseButton pr={2} onClick={(e) => removeItem(c)} />
              </Tag>
            ))}
        </HStack>
      ) : (
        ''
      )}
      {selected?.length >= max ? (
        ''
      ) : (
        <div ref={containerRef} style={{ width: '100%' }}>
          <Popover
            // {...disc}
            matchWidth={true}
            isOpen={focused}
            initialFocusRef={inputRef}
            placement="bottom-start"
          >
            <PopoverTrigger>
              <InputGroup>
                <Input
                  ref={inputRef}
                  borderRadius="full"
                  onClick={(e) => setFocused(!focused)}
                  onBlur={(e) => setFocused(false)}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={t('profileTestimonials.searchConnections') || "Search connections..."}
                  // textTransform={"capitalize"}
                  {...props}
                />
              </InputGroup>
            </PopoverTrigger>
            {focused && allDegreeConnections?.length > 0 ? (
              <PopoverContent p={0} w="100%" maxH="200px" overflowY="auto">
                <PopoverBody p={0}>
                  <List>
                    {allDegreeConnections
                      ?.filter((c) => !selected?.includes(c.id))
                      ?.filter((c) => {
                        if (type === 'give') {
                          return !givenTestimonials?.some(
                            (testimonial) => testimonial?.asker?.id === c?.id
                          );
                        } else {
                          return !requestedTestimonials?.some(
                            (testimonial) => testimonial?.giver?.id === c?.id
                          );
                        }
                      })
                      ?.filter?.((c) =>
                        getUserFullName(c)
                          ?.toLowerCase?.()
                          ?.includes(search?.toLowerCase?.())
                      )
                      ?.map?.((c, cind) => (
                        <ListItem
                          key={c?.id}
                          _hover={{
                            bg: 'gray.100',
                          }}
                          px={4}
                          py={2}
                          onClick={(e) => onSelect(c)}
                        >
                          <HStack>
                            <Avatar size="sm" src={c?.profile_pic} name={getUserFullName(c)} />
                            <Text>{getUserFullName(c)}</Text>
                          </HStack>
                        </ListItem>
                      ))}
                  </List>
                </PopoverBody>
              </PopoverContent>
            ) : (
              ''
            )}
          </Popover>
        </div>       
      )}
    </Stack>
  );
};
